import { GameSettingsComponent } from 'components/providers/GameSettings';
import { AnalyticsComponent } from 'components/providers/Analytics';
import { GameScoreComponent } from 'components/providers/GameScore';
import { LeapAuthComponent } from 'components/providers/LeapAuth';
import { UserDrmComponent } from 'components/providers/UserDrm';
import React from 'react';


export function ProvidersStackComponent({ children }) {
    return (
        <LeapAuthComponent>
            <UserDrmComponent>
                <GameScoreComponent>
                    <GameSettingsComponent>
                        <AnalyticsComponent>
                            {children}
                        </AnalyticsComponent>
                    </GameSettingsComponent>
                </GameScoreComponent>
            </UserDrmComponent>
        </LeapAuthComponent>
    );
};